import React from "react";
import { Dialog, DialogTitle, ListItem, ListItemButton, ListItemText, List } from "@mui/material";

interface IProps {
  open: boolean;
  onSelected: (name: string | null) => void;
  workSheets: string[];
}

const WorkSheetSelector = ({workSheets, open, onSelected}: IProps): React.ReactElement => {

  const handleClose = () => onSelected(null);

  const handleListItemClick = (value: string) => onSelected(value);

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle style={{ background: "rgba(0, 0, 0, 0.1)" }}>Select the WorkSheet</DialogTitle>
      <List sx={{ pt: 0 }}>
        {workSheets.map((workSheet) => (
          <ListItem disablePadding key={workSheet}>
            <ListItemButton onClick={() => handleListItemClick(workSheet)}>
              <ListItemText primary={workSheet} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Dialog>
  );
}

export default WorkSheetSelector;